"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var RETRY_STATUS_CODE = 206;
var RETRY_WAIT_TIME = 1000;

var StoriesAPIClient =
/*#__PURE__*/
function () {
  function StoriesAPIClient(baseUrl, apiKey) {
    _classCallCheck(this, StoriesAPIClient);

    this.baseUrl = baseUrl;
    this.apiKey = apiKey;
    this.client = this.buildClient();
  }

  _createClass(StoriesAPIClient, [{
    key: "buildClient",
    value: function buildClient() {
      var _this = this;

      var storyAPIRequest = _axios.default.create();

      var sleepRequest = function sleepRequest(milliseconds, originalRequest) {
        return new Promise(function (resolve, reject) {
          setTimeout(function () {
            return resolve(storyAPIRequest(originalRequest));
          }, milliseconds);
        });
      };

      storyAPIRequest.interceptors.request.use(function (config) {
        // Set API Key
        config.headers.Authorization = "Api-Key " + _this.apiKey; // Parse slug with base url

        if (!config.url.startsWith("http")) {
          config.url = "".concat(_this.baseUrl, "/api/").concat(config.url);
        }

        return config;
      });
      storyAPIRequest.interceptors.response.use(function (response) {
        var config = response.config,
            data = response.data,
            status = response.status;

        if (status === RETRY_STATUS_CODE && data && data.retry_url) {
          var newConfig = _objectSpread({}, config);

          newConfig.url = data.retry_url;
          newConfig.params = {};
          return sleepRequest(RETRY_WAIT_TIME, newConfig);
        }

        return data;
      });
      return storyAPIRequest;
    }
  }, {
    key: "request",
    value: function request(slug, callback, err) {
      return this.client.get(slug).then(function (data) {
        return callback(data);
      }, function (error) {
        console.log(error);
        return err(error);
      });
    }
  }, {
    key: "story",
    value: function story(slug, collection, page, q, callback, err) {
      if (collection !== null) {
        slug += "?collection=".concat(collection);

        if (page) {
          slug += "&page=".concat(page);
        }

        ;

        if (q) {
          slug += "&q=".concat(q);
        }
      }

      ;
      return this.request("story/" + slug, callback, err);
    }
  }, {
    key: "collection",
    value: function collection(slug, callback, err) {
      return this.request("collection/" + slug, callback, err);
    }
  }]);

  return StoriesAPIClient;
}();

exports.default = StoriesAPIClient;